import React, { useContext } from 'react';

import strings from 'common/strings';
import permissions from 'common/permissions';
import { testIds, generateTestId } from 'common/testIds';
import { VehicleCardTabType } from 'models';

import VehicleCardReconDetails from './VehicleCardReconDetails';
import VehicleCardInventoryDetails from './VehicleCardInventoryDetails';
import VehicleCardEngageDetails from './VehicleCardEngageDetails';
import { VehicleCardContext } from '../../VehicleCard';
import { usePermissions } from 'hooks';

var VehicleCardReconInventoryTabs = () => {
  const {
    inExtensionCardMode,
    position,
    forceShowEngageTab,
    setCurrentTab,
    currentTab,
  } = useContext(VehicleCardContext);
  const onClick = (activeCollectionType: VehicleCardTabType) => {
    if (setCurrentTab !== undefined) {
      setCurrentTab(activeCollectionType);
    }
  };
  const { hasPermission } = usePermissions();

  return (
    <>
      <div className="VehicleCard-recon-inventory-tabs-container">
        {hasPermission(permissions.RECON_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3  ${
              currentTab === 'recon' ? 'active' : ''
            }`}
            onClick={() => onClick('recon')}
            data-vas-testing={generateTestId(testIds.INVENTORY_CARD_RECON_TAB, {
              position: position.toString(),
            })}
          >
            {strings.RECON}
          </div>
        )}
        {hasPermission(permissions.INVENTORY_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'inventory' ? 'active' : ''
            }`}
            onClick={() => onClick('inventory')}
            data-vas-testing={generateTestId(
              testIds.INVENTORY_CARD_INVENTORY_TAB,
              {
                position: position.toString(),
              }
            )}
          >
            {strings.INVENTORY}
          </div>
        )}
        {hasPermission(permissions.PLUGIN_VELOCITYENGAGE_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'engage' ? 'active' : ''
            }`}
            onClick={() => onClick('engage')}
            data-vas-testing={generateTestId(
              testIds.INVENTORY_CARD_ENGAGE_TAB,
              {
                position: position.toString(),
              }
            )}
          >
            {strings.ENGAGE}
          </div>
        )}
      </div>
      <div className={`VehicleCard-footer VehicleCard-footer-${currentTab}`}>
        <div className="VehicleCard-recon-inventory-tab-content full-height">
          {currentTab === 'recon' && <VehicleCardReconDetails />}
          {currentTab === 'inventory' && <VehicleCardInventoryDetails />}
          {currentTab === 'engage' &&
            (forceShowEngageTab || inExtensionCardMode) && (
              <VehicleCardEngageDetails />
            )}
        </div>
      </div>
    </>
  );
};

export default VehicleCardReconInventoryTabs;
